import { Button } from './ui/Button';
import { CardTitle } from './ui/card';

interface MoveToPRScreenProps {
  responseState: string;
  responseMsg?: string;
  trackingId: string;
  title?: string;
  children?: React.ReactNode;
  handleCancel: () => void;
}

export const MoveToPRScreen = ({
  responseState,
  responseMsg,
  trackingId,
  title = 'Disposition',
  children,
  handleCancel,
}: MoveToPRScreenProps) => {
  return (
    <div className="-mx-4 -mb-6 flex min-h-full flex-col items-center px-6 pb-6 pt-8">
      <CardTitle className="mb-1 flex items-center justify-center gap-3 text-center text-xl font-extrabold tracking-tight text-white">
        {title}
      </CardTitle>
      <h1 className="text-white font-bold text-lg mb-5"> Tracking# {trackingId}</h1>

      <div className="w-full flex flex-col items-center gap-4 mb-8">
        <Button
          type="button"
          className="h-14 w-full rounded-2xl bg-white text-lg font-bold text-red-700 shadow-lg hover:bg-red-50"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        {children}
        <p className="text-2xl font-black text-white uppercase tracking-wide text-center">
          Move to Problems Team
        </p>
      </div>

      <div className="flex flex-col items-center gap-6 text-center">
        <div className="animate-pulse">
          <div className="flex h-28 w-28 items-center justify-center rounded-full bg-white/20 ring-4 ring-white/40 ring-offset-2 ring-offset-red-700">
            <span className="text-6xl">⚠️</span>
          </div>
        </div>

        <div className="space-y-1">
          <h2 className="text-3xl font-black uppercase tracking-widest text-white">
            {responseState} {'  '}
            Detected
          </h2>
        </div>

        {responseMsg && (
          <div className="w-full max-w-sm rounded-2xl border border-white/20 bg-white/10 p-4">
            <p className="text-3xl font-black text-white uppercase">{responseMsg}</p>
          </div>
        )}
      </div>
    </div>
  );
};
